import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { Modal } from "ui";

import { useDeleteNotification } from "../../../apis";
import { DeleteNotificationModalProps } from "./DeleteSharingScheduleModal.types";

import styles from "./DeleteNotificationModal.module.scss";

const DeleteNotificationModal = ({
  isOpen,
  id,
  onClose,
  onDeleteSuccess
}: DeleteNotificationModalProps) => {
  const { t } = useTranslation();

  const deleteNotification = useDeleteNotification({
    onSuccess: () => {
      onClose();
      onDeleteSuccess();
      toast.success(t("Notification deleted successfully"));
    }
  });

  const onDeleteInventoryManager = () => {
    deleteNotification.mutate(id);
  };

  return (
    <Modal
      type="delete"
      isOpen={isOpen}
      title={t("Delete Notification")}
      isLoading={deleteNotification.isLoading}
      okText={t("Delete")}
      onOk={onDeleteInventoryManager}
      contentClassName={styles.modal}
      onClose={onClose}
    >
      <p className={styles.deleteManagerModal_text}>
        {t("Are you sure you want to delete this notification?")}
      </p>
    </Modal>
  );
};

export default DeleteNotificationModal;
